
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.18 11.403c0-5.325 4.224-9.66 9.318-9.66 5.093 0 9.317 4.335 9.348 9.66 0 3.22-1.553 6.026-3.727 7.652v2.392c0 .67-.559 1.211-1.211 1.275l-8.541.701h-.125a1.26 1.26 0 0 1-.87-.35c-.248-.224-.465-.574-.465-.925v-3.125c-2.485-1.753-3.727-4.368-3.727-7.62zm12.424 6.919c0-.447.217-.893.62-1.116 1.957-1.084 3.075-3.252 3.107-5.803 0-3.922-3.075-7.11-6.833-7.11-3.759 0-6.834 3.188-6.802 7.11 0 2.614.993 4.528 3.136 5.803.373.255.56.67.56 1.116v2.455l6.212-.51v-1.945z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m19.816 26.798-8.48.638h-.093c-.652 0-1.18-.51-1.242-1.18a1.271 1.271 0 0 1 1.15-1.371l8.479-.638a1.224 1.224 0 0 1 1.335 1.18 1.271 1.271 0 0 1-1.15 1.371zm-2.701 4.02-3.044.255h-.093c-.652 0-1.18-.51-1.243-1.18a1.271 1.271 0 0 1 1.15-1.37l3.074-.256a1.235 1.235 0 0 1 1.305 1.18 1.271 1.271 0 0 1-1.15 1.37zm3.322-19.447c-.062.574-.528 1.02-1.087 1.02h-.093a1.1 1.1 0 0 1-.963-1.211c.186-1.818-1.367-2.487-1.553-2.55-.56-.224-.839-.862-.652-1.436.186-.574.807-.892 1.366-.67 1.15.415 3.262 1.978 2.982 4.847z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 32 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.18 11.403c0-5.325 4.224-9.66 9.318-9.66 5.093 0 9.317 4.335 9.348 9.66 0 3.22-1.553 6.026-3.727 7.652v2.392c0 .67-.559 1.211-1.211 1.275l-8.541.701h-.125c-.31 0-.652-.127-.87-.35-.248-.224-.465-.574-.465-.925v-3.125c-2.485-1.753-3.727-4.368-3.727-7.62zm12.424 6.919c0-.447.217-.893.62-1.116 1.957-1.084 3.075-3.252 3.107-5.803 0-3.922-3.075-7.11-6.833-7.11-3.759 0-6.834 3.188-6.802 7.11 0 2.614.993 4.528 3.136 5.803.373.255.56.67.56 1.116v2.455l6.212-.51v-1.945z\" fill=\"#000000\"/>\r\n    <path d=\"m19.816 26.798-8.48.638h-.093c-.652 0-1.18-.51-1.242-1.18a1.271 1.271 0 0 1 1.15-1.371l8.479-.638a1.224 1.224 0 0 1 1.335 1.18 1.271 1.271 0 0 1-1.15 1.371zM17.115 30.818l-3.044.255h-.093c-.652 0-1.18-.51-1.243-1.18a1.271 1.271 0 0 1 1.15-1.37l3.074-.256a1.235 1.235 0 0 1 1.305 1.18 1.271 1.271 0 0 1-1.15 1.37zM20.437 11.371c-.062.574-.528 1.02-1.087 1.02h-.093a1.1 1.1 0 0 1-.963-1.211c.186-1.818-1.367-2.487-1.553-2.55-.56-.224-.839-.862-.652-1.436.186-.574.807-.892 1.366-.67 1.15.415 3.262 1.978 2.982 4.847z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-light.e25c69a3b9cef6b8a579e6107ea17984.svg"),
        {
          React: SvgIconLight,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      